function matchheight() {

    $(".grid-item__content .grid-item__title").matchHeight(); 
    $(".grid-view-item  .product-grid--title").matchHeight(); 
    $(".testimonials--text-wrapper p").matchHeight();

}
$(window).on("load", function () { 
matchheight();

});


$(document).ready(function(){ 
  $('#bundle-product-select').change(function() {
    // set the window's location property to the value of the option the user has selected
    window.location = $(this).val();
  });
  
  var pusharr = [];
  $( ".bundle-variant a .variant-btn").click(function() {
    var img_url = $(this).parent().attr('data-img-url');
    var title = $(this).parent().attr('data-title');
    if(pusharr.length < 12){ 
      pusharr.push({'imgurl':img_url,'title':title});
      bundleLogic(pusharr);
    }
  });
});

function bundleLogic(bundleObj) {
  var countindex = 12 - bundleObj.length;
  
  if(countindex == 0){
    $('.pick-btn').addClass('added-bundles').addClass('btn').html('Add To Cart');
    addedbundle();
    console.log('0',countindex);
  } else {
    $('.pick-btn').removeClass('added-bundles').removeClass('btn').html('Pick <span class="pick-count">'+countindex+'</span> more');
    console.log('1',countindex);
    addedbundle();
  }
  
  var html = '<ul>';
  for(var i=0;i<12;i++){
    var idx = i+1;
    if(bundleObj[i]){
      html += '<li data-index="'+idx+'"><div class="product__img img'+idx+'"><img src='+ bundleObj[i].imgurl +'><span class="icon--clear-bundle"></span></div></li>';
      $('[name="properties[flavors-'+idx+']"]').val($.trim(bundleObj[i].title));
      $('.pick-count').text(countindex);
    } else {
      html += '<li data-index="'+idx+'"><div class="product__img img'+idx+'"></div></li>';
      $('[name="properties[flavors-'+idx+']"]').val('');
    }
  }
  html += '</ul>';
  $('.product__photos-bundle').html(html);
  removebundle(bundleObj);
}

function removebundle(bundleObj){
  $('.icon--clear-bundle').click(function(){
    var removeIndexd = $(this).closest('li').attr('data-index');
    removeIndexd = removeIndexd -1;
    
    bundleObj.splice(removeIndexd, 1);
    bundleLogic(bundleObj);
  });
}

function addedbundle(){
  $('.pick-btn.added-bundles').click(function(){
    if($('.pick-btn.added-bundles').length > 0){
      $('#AddToCart').click();
    } else {
      return false;
    }
  });
}